import { InjectionToken } from '@angular/core';
import { JsonConvert, OperationMode, ValueCheckingMode } from 'json2typescript';

export const JSON_CONVERT_TOKEN = new InjectionToken<JsonConvert>('JsonConvert', {
  factory: (): JsonConvert => new JsonConvert(OperationMode.ENABLE, ValueCheckingMode.ALLOW_NULL)
});
